import React from 'react';
import { Container } from 'react-bootstrap';

function Year3 () {
    return (
        <div>
            <Container>
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th colspan="2">Name</th>
      <th scope="col">Download</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">5th Sem</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/drive/folders/1PgGThpJtIxgM5Mwav8BYDZ5j42dRUKD2' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
        <th scope='row'>2</th>
        <td colspan="2">6th Sem</td>
        <td><a style={{textDecoration:'none'}} href='https://drive.google.com/drive/folders/1LIUMCvyMgtDeiCdc_oeiWD9M_EgXeEX-' download> Open <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
  </tbody>
</table>
</Container>
        </div>
    );
}

export default Year3;
